<template>
  <div class="container white" style="padding: 48px 0 0 0">
    <v-layout column class="menu w-100 white">
      <v-card elevation="2" tile>
        <v-layout
          align-center
          justify-space-around
          class="py-2 px-3 colorSelectedBack sizeTop"
        >
          <img
            :src="require(`@/assets/logos/uc_carsharing_branco.png`)"
            alt="pickndrive"
            style="width: auto; height: 39px"
          />
        </v-layout>
      </v-card>
    </v-layout>

    <div
      class="pt-6 pl-6  text-center info-reservation"
      v-if="this.reserva == 'true'"
    >
      <img
        class="float-left pt-1"
        src="../../assets/icons/back.png"
        @click="accept()"
      />
      <strong>Informações da reserva</strong>
    </div>

    <div
      class="pt-6 pl-6  text-center info-reservation"
      v-if="this.reserva == 'false'"
    >
      <img class="pt-0 pr-4 gif" src="../../assets/confirmation.gif" />
      <strong>Reserva realizada com sucesso!</strong>
    </div>

    <div class="pt-8 pl-4 info-reservation">
      <strong>O que você precisa saber sobre sua reserva:</strong>
    </div>

    <v-row class="icon pl-4">
      <v-col class="pb-2 pa-4">
        <img src="../../assets/icons/localization.png" />
      </v-col>
    </v-row>

    <div class="pt-2 pa-3 title"><strong>Check-in antecipado</strong></div>

    <div class="pt-2 pa-3">
      Você pode realizar o seu check-in {{ this.limit_minutes_checkin }} minutos
      antes da sua reserva.
    </div>

    <v-row class="icon pl-4">
      <v-col>
        <img src="../../assets/icons/checkout.png" />
      </v-col>
    </v-row>

    <div class="pt-2 pa-3 title"><strong>Check-out</strong></div>

    <div class="pt-2 pa-3">
      É importante cumprir prazos com o carro compartilhado. Mas caso aconteça
      algum imprevisto, você terá {{ this.limit_minutes_checkout }} minutos de
      tolerância para realizar o check-out. Caso ultrapasse esse tempo, será
      cobrada um multa conforme descrito nos termos de responsabilidade. Também
      é necessário entregar o carro com pelo menos 1/4 do combustível para que o
      próximo usuário consiga utilizar o carro.
    </div>

    <v-row class="icon pl-4">
      <v-col>
        <img src="../../assets/icons/supply.png" />
      </v-col>
    </v-row>

    <div class="pt-2 pa-3 title">
      <strong>Abastecimento por nossa conta</strong>
    </div>

    <div class="pt-2 pa-3">
      Para realizar um abastecimento, basta utilizar o cartão combustível
      disponível no porta-luvas do do carro em um dos
      <strong>postos conveniados.</strong> O combustível deve ser sempre
      <strong>ÁLCOOL.</strong> Mas lembre-se, para o abastecimento ser por nossa
      conta, você deve seguir todos esses critérios.
    </div>

    <div class="pt-6 pa-3 text-center agreed-stations">
      <v-btn
        large
        text
        class="agreed-posts"
        style="width: 96%"
        href="https://maps.goodcard.com.br/ondecomprar/index.php?portal=ticketlog"
      >
        <span><strong>VER POSTOS CONVENIADOS</strong></span>
      </v-btn>
    </div>

    <div class="text-center w-100 mt-4 pb-16">
      <v-btn
        large
        style="width: 96%"
        class="btnColor mx-0 white--text"
        @click="accept()"
      >
        <span>ENTENDI</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import Configuration from "../../controllers/ConfigurationController.js";
import VehicleRequestController from "../../controllers/VehicleRequestController";
import VehicleRequest from "../../models/VehicleRequest.js";

export default {
  created() {
    this.reserva = localStorage.getItem("showInfo");
    this.vehicleRequest.client_id = localStorage.getItem("client_id");
    this.getConfigurations();
  },

  data() {
    return {
      reserva: true,
      limit_minutes_checkin: 0,
      limit_minutes_checkout: 0,
      configurationController: new Configuration(this.$resource),
      vehicleRequest: new VehicleRequest(),
      vehicleRequestController: new VehicleRequestController(this.$resource)
    };
  },

  methods: {
    accept() {
      console.log(localStorage.getItem("showInfo"));
      localStorage.setItem("showInfo", String(false));
      this.reserva = localStorage.getItem("showInfo");
      this.$router.push({ name: "driver-vehicle-request-dashboard" });
    },

    back() {
      console.log(localStorage.getItem("showInfo"));
      localStorage.setItem("showInfo", String(false));
      this.reserva = localStorage.getItem("showInfo");
      this.$router.push({ name: "driver-vehicle-request-dashboard" });
    },

    async getConfigurations() {
      let configs = await this.configurationController.getAll(
        this.vehicleRequest.client_id
      );
      console.log(configs, "CONFIGURACAO");

      this.limit_minutes_checkin = configs.limit_minutes_before_checkin.value;
      this.limit_minutes_checkout = configs.limit_minutes_before_checkout.value;
    }
  }
};
</script>

<style>
.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}
.colorSelectedBack {
  background-color: var(--secondary-color) !important;
}

.container {
  position: relative;
  height: 100vh;
  background: #fcfcfc;
}

.teste {
  padding-top: 80px;
}

.icon {
  bottom: 120px;
}

.title {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  font-weight: bold;
}

.info-reservation {
  font-size: 18px;
}

.agreed-stations {
  color: var(--primary-color) !important;
  text-decoration: underline;
}

.btnColor {
  background-color: var(--primary-color) !important;
}

.btnInfo {
  background-color: white;
}

.gif {
  max-width: 30;
  max-height: 30px;
  width: auto;
  height: auto;
}

.agreed-posts {
  color: var(--primary-color) !important;
}
</style>
